import {Record} from 'immutable';

const DEFAULT_STATE = {
  currentRoute: null,
  prevRoute: null,
};

const BaseRecord = Record(DEFAULT_STATE);

export class RouteStateRecord extends BaseRecord {}



// WEBPACK FOOTER //
// ./src/state/route/RouteStateRecord.js